import { ConnectedProps, connect } from 'react-redux';
import { HoldingPage as Component } from './HoldingPage';

const mapStateToProps = () => ({});

const connector = connect(mapStateToProps, undefined);

export type IHoldingPageStoreProps = ConnectedProps<typeof connector>;

export const HoldingPage = connector(Component);
